module.exports = __webpack_public_path__ + "img/renfrewshire_leisure_logo.551d5d8d.png";